export default __webpack_public_path__ + "static/media/xp-star.714b4911.svg";